module.exports = __webpack_public_path__ + "static/media/logo.5da14d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/logo.png
// module id = 26
// module chunks = 0